import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, mergeProps as _mergeProps, createVNode as _createVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e64a6fa4"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "content",
  ref: "elContent"
}

import { ref, withDefaults, watch, DefineComponent, computed } from 'vue';

export interface PropsOptions {
	shown: boolean,
	selectedTab: string|null,
	tabs: {
		fileSystem: IDESideBarContentTabFileSystem.PropsOptions,
		settings: IDESideBarContentTabSettings.PropsOptions,
		download: IDESideBarContentTabDownload.PropsOptions,
	},
}


import * as IDESideBarContentTabFileSystem from './IDESideBarContentTabFileSystem.vue';
import * as IDESideBarContentTabDownload from './IDESideBarContentTabDownload.vue';
import * as IDESideBarContentTabSettings from './IDESideBarContentTabSettings.vue';

export const EmitsOptions = {
	'tabs:fileSystem:onClickDirectory' : IDESideBarContentTabFileSystem.EmitsOptions['onClickDirectory'],
	'tabs:fileSystem:onClickFile' : IDESideBarContentTabFileSystem.EmitsOptions['onClickFile'],
	'tabs:download:onDownload' : IDESideBarContentTabDownload.EmitsOptions['onDownload'],
	'tabs:settings:onSettingsChanged' : IDESideBarContentTabSettings.EmitsOptions['onSettingsChanged'],
}

export default /*#__PURE__*/_defineComponent({
  __name: 'IDESideBarContent',
  props: {
    shown: { type: Boolean, default() {
		return true;
	} },
    selectedTab: { default() {
		return null;
	} },
    tabs: null
  },
  emits: EmitsOptions,
  setup(__props: any, { expose, emit }) {

const props = __props as { shown: boolean, selectedTab: string|null, tabs: {
		fileSystem: IDESideBarContentTabFileSystem.PropsOptions,
		settings: IDESideBarContentTabSettings.PropsOptions,
		download: IDESideBarContentTabDownload.PropsOptions,
	} }






const width = ref(250);

const widthConstraints = {
	min: 200,
	max: 600,
};

// definice method, ktere mohou volat jine komponenty z venku
expose({
	getWidth() {
		return width.value;
	},
	setWidth(newWidth:number) {
		width.value = Math.min(Math.max(newWidth, widthConstraints.min), widthConstraints.max);
	},
});


const title = computed(() => {
	if (props.selectedTab == null) {
		return '';
	}
	return {
		'fileSystem': 'Soubory',
		'download': 'Stažení souborů',
		'settings': 'Nastavení',
	}[props.selectedTab];
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["IDESideBarContent", {shown: __props.shown}]),
    style: _normalizeStyle({width: `${width.value}px`})
  }, [
    _createElementVNode("h1", null, _toDisplayString(_unref(title)), 1),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        class: _normalizeClass(["fileSystem", {shown: __props.selectedTab == 'fileSystem'}])
      }, [
        _createVNode(IDESideBarContentTabFileSystem.default, _mergeProps(__props.tabs.fileSystem, {
          onOnClickDirectory: _cache[0] || (_cache[0] = (...args) => emit('tabs:fileSystem:onClickDirectory', ...args)),
          onOnClickFile: _cache[1] || (_cache[1] = (...args) => emit('tabs:fileSystem:onClickFile', ...args))
        }), null, 16)
      ], 2),
      _createElementVNode("div", {
        class: _normalizeClass(["download", {shown: __props.selectedTab == 'download'}])
      }, [
        _createVNode(IDESideBarContentTabDownload.default, _mergeProps(__props.tabs.download, {
          onOnDownload: _cache[2] || (_cache[2] = (...args) => emit('tabs:download:onDownload', ...args))
        }), null, 16)
      ], 2),
      _createElementVNode("div", {
        class: _normalizeClass(["settings", {shown: __props.selectedTab == 'settings'}])
      }, [
        _createVNode(IDESideBarContentTabSettings.default, _mergeProps(__props.tabs.settings, {
          onOnSettingsChanged: _cache[3] || (_cache[3] = (...args) => emit('tabs:settings:onSettingsChanged', ...args))
        }), null, 16)
      ], 2)
    ], 512)
  ], 6))
}
}

})